module.exports = __webpack_public_path__ + "static/media/rastapank-logo-967_192.f21953ff.png";